// MathJax脚本的源地址
// const MATH_JAX_SRC = 'https://mathjax.cdnjtzy.com/static/hy/mathjax_274/mathjax/MathJax.js?config=svgsnippet-update20201111';
const MATH_JAX_SRC = 'https://mathresource.studyquicks.com/static/js/mathjax/MathJax.js?config=svgsnippet-update20231201';
let scriptInserted = false; // 确保变量 scriptInserted 被定义和初始化

async function createMathJaxScript(): Promise<void> {
  try {
    const script = document.createElement('script');
    if (!scriptInserted) {
      script.src = MATH_JAX_SRC;
      script.async = true;
      document.head.appendChild(script);
      scriptInserted = true; // 设置为true，防止再次插入
    } else {
      // 如果脚本已经被插入，无需等待，直接返回
      return;
    }

    // 等待MathJax脚本加载完成
    await new Promise(resolve => (script.onload = resolve));

    // 没有错误处理，因为script加载过程中的错误会被抛出
  } catch (error) {
    // 异常处理逻辑，例如显示错误信息
    console.log('加载MathJax脚本出错：', error);
  }
}

/**
 * 加载MathJax并设置指定元素中的数学内容
 * @param {string} id - 元素ID
 * @param {string} [content] - 数学内容
 * @returns {Promise<void>}
 */
export function loadMathJax(id: string, content?: string): Promise<void> {
  return createMathJaxScript()
    .then(() => {
      if ((window as any).MathJax && id) {
        const typesetFunction = ['Typeset', (window as any).MathJax.Hub, document.getElementById(id)];
        return (window as any).MathJax.Hub.Queue(typesetFunction);
      } else {
        return Promise.resolve();
      }
    })
    .catch(error => {
      console.log('渲染MathJax时发生错误:', error);
      return Promise.reject(error);
    });
}

export function renderMathJax(id: string, content?: string): Promise<void> {
  return loadMathJax(id, content)
    .then(() => {
      return Promise.resolve();
    })
    .catch(error => {
      console.log('渲染MathJax时发生错误:', error);
      return Promise.reject(error);
    });
}

// 使用函数调用的情况
// loadMathJax('mathElementId', '这里有一些数学内容').then(() => {
//   console.log('MathJax渲染完成');
// }).catch((error) => {
//   console.error('渲染MathJax时发生错误:', error);
// });
